/**
 * Tonight stage strip — one Layer-1 hop for Before / During.
 * Hash stays in hashFromCcGo. Frozen CMC desks do not import this.
 */

function esc(v) {
  return String(v == null ? "" : v)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

/**
 * @param {{
 *   stage?: "before"|"during",
 *   active?: string,
 *   eventId?: string,
 *   extra?: Array<{ dest: string, id?: string, label: string, current?: boolean }>,
 * }} [opts]
 */
export function buildTonightStageStripHtml(opts) {
  const o = opts || {};
  const stage = String(o.stage || "during").toLowerCase() === "before" ? "before" : "during";
  const active = String(o.active || "").trim().toLowerCase();
  const eventId = String(o.eventId || "").trim();
  const items = stage === "before"
    ? [
      { dest: "readiness", label: "Score", key: "score" },
      { dest: "readiness?tab=health", label: "Device health", key: "health" },
      { dest: "response-drill", label: "Run drill", key: "drill" },
      { dest: "response-plans", label: "Plans", key: "plans" },
      { dest: "response-plans?tab=sop", label: "Playbook", key: "playbook" },
    ]
    : [
      { dest: "incidents", label: "Incidents", key: "cases" },
      { dest: "response", label: "Assignments", key: "assign" },
      {
        dest: "orchestration",
        extra: eventId,
        label: "Loop",
        key: "loop",
      },
      { dest: "overview", label: "Home", key: "home" },
    ];
  const extras = Array.isArray(o.extra) ? o.extra : [];
  const kicker = stage === "before" ? "Before" : "During";
  const aria = stage === "before" ? "Before tonight" : "During tonight";
  const row = items.concat(extras.map((x, i) => ({
    dest: x.dest,
    extra: x.id,
    label: x.label,
    key: `x${i}`,
    current: !!x.current,
  }))).map((it) => {
    const on = it.current === true || it.key === active;
    const extra = it.extra ? ` data-cc-id="${esc(it.extra)}"` : "";
    return `<button type="button" class="btn sm ${on ? "" : "secondary"} btn-tap" data-cc-go="${esc(it.dest)}"${extra} aria-current="${on ? "page" : "false"}">${esc(it.label)}</button>`;
  }).join("");
  return `<nav class="croc-stage-tabs croc-before-tabs" data-stage="${stage}" aria-label="${aria}">
    <p class="croc-stage-tabs__k croc-before-tabs__k">${kicker}</p>
    <div class="croc-stage-tabs__row croc-before-tabs__row">${row}</div>
  </nav>`;
}
